import styles from "./Maintenance.module.scss";
import layoutStyles from "../Layout/Layout.module.scss";
import logo from "../../assets/images/logo.svg";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import {Outlet} from "react-router";
import React from "react";

const MaintenanceLayout = () => {

    return (
        <div className={styles.layout}>
            <div className={layoutStyles.navbar}>
                <img className={layoutStyles.logo} src={logo} alt="Logo" />
                <div className={layoutStyles.menu}>
                    <LanguageSwitcher />
                </div>
            </div>
            <div className={styles.content}>
                <Outlet />
            </div>
        </div>
    );
};

export default MaintenanceLayout;
